import { FooterColumns } from './FooterColumns';






export const SiteFooter = ({ handleWhatsAppClick }) => (
<footer className="bg-gradient-to-b from-gray-950 to-black border-t-2 border-red-900/50 py-8 md:py-12 relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1710676827496-b674050284ba" 
            alt="Cosmos mystique" 
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <FooterColumns handleWhatsAppClick={handleWhatsAppClick} />
          
          <div className="border-t-2 border-red-900/40 pt-8">
            <div className="text-center mb-6">
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                © 2025 <strong className="text-white">Maître Diamma</strong> - Grand Marabout Sorcier Vaudou Guadeloupe - 
                Spécialiste Retour Affectif Rapide - Tous droits réservés
              </p>
            </div>
            <div className="text-center">
              <p className="text-xs text-gray-500 leading-relaxed">
                <strong className="text-red-400">Mots-clés SEO:</strong> Marabout Guadeloupe • Sorcier Vaudou Guadeloupe • Retour Affectif Guadeloupe • 
                Voyant Guadeloupe • Magie Blanche Guadeloupe • Magie Rouge Guadeloupe • Magie Noire Guadeloupe • 
                Désenvoutement Guadeloupe • Médium Guadeloupe • Guérisseur Guadeloupe • Rituel Amour • Récupérer son Ex • 
                Marabout Pointe-à-Pitre • Voyant Les Abymes • Retour Affectif Baie-Mahault • Magie Blanche Le Gosier • 
                Sorcier Vaudou Authentique • Grand Marabout • Voyant Sérieux • Rituel Puissant
              </p>
            </div>
          </div>
        </div>
      </footer>
);
